package com.elan.edubridge.shared.domain.policy

import com.elan.edubridge.shared.domain.model.Permission
import com.elan.edubridge.shared.domain.model.UserRole

/**
 * 역할 → 권한 파생의 유일한 정의(§2.2).
 *
 * Functions가 멤버십을 쓸 때 이 매핑 결과를 `AcademyMembership.permission`에 저장하고,
 * rules는 저장된 값만 읽는다. 같은 매핑이 `functions/src/common/auth.ts`에 TS로 한 벌 더 있으므로
 * 둘이 어긋나면 승인 트랜잭션 검증(S2 단언 ⑤)에서 잡힌다.
 *
 * 보호자는 이 매핑에 없다 — 학원 멤버십 자체를 받지 않으므로 파생할 권한도 없다.
 */
object PermissionPolicy {
    fun permissionFor(role: UserRole): Permission = when (role) {
        UserRole.STUDENT -> Permission.VIEWER
        UserRole.TEACHER -> Permission.EDITOR
        UserRole.ACADEMY_OWNER, UserRole.SUPER_ADMIN -> Permission.ADMIN
    }
}
